(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["planificador-granel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOLIDOS = ['Grano', 'Molido cafetera expreso', 'Molido cafetera italiana', 'Molido cafetera americana (filtro de papel)'];
    var FUERA = ['recetas', 'sin gluten', 'sin-gluten', 'saludable', 'antiinflamatorio', 'superalimentos', 'guia', 'indice', 'despensa viva', 'cocina visual'];
    var TILDES = { reposteria: 'Repostería', mexico: 'México', cuscus: 'Cuscús', chia: 'Chía', 'agar agar': 'Agar-agar', 'agar-agar': 'Agar-agar', azafran: 'Azafrán', curcuma: 'Cúrcuma', japon: 'Japón', cafe: 'Café', platano: 'Plátano', otono: 'Otoño', anis: 'Anís', asiatica: 'Asiática', datiles: 'Dátiles', te: 'Té', 'te verde': 'Té verde', 'te matcha': 'Té matcha', libano: 'Líbano', 'panaderia casera': 'Panadería casera', 'plato de cuchara': 'Plato de cuchara' };
    function bonita(t) { return TILDES[t] || (t.charAt(0).toUpperCase() + t.slice(1)); }
    function eur(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    function gramos(txt) {
      var m = String(txt || '').toLowerCase().replace(',', '.').match(/(\d+(?:\.\d+)?)\s*(kg|g)\b/);
      return m ? Math.round(parseFloat(m[1]) * (m[2] === 'kg' ? 1000 : 1)) : 0;
    }
    function fmtG(g) { return g >= 1000 ? (g / 1000).toString().replace('.', ',') + ' kg' : g + ' g'; }
    function gcd(a, b) { return b ? gcd(b, a % b) : a; }

    // Formatos de un producto: solo variantes disponibles con gramos legibles y, si hay otra opción
    // (p. ej. molido en la variante), las que comparten esa opción con la primera disponible.
    function formatos(prod) {
      var vs = (prod.v || []).map(function (x) {
        var opts = x[1] || [];
        var gi = -1, g = 0;
        opts.forEach(function (o, i) { var gg = gramos(o); if (gg && gi < 0) { gi = i; g = gg; } });
        return { id: x[0], g: g, p: x[2], ok: x[3] === true, key: opts.filter(function (o, i) { return i !== gi; }).join('|') };
      }).filter(function (f) { return f.g > 0; });
      var disp = vs.filter(function (f) { return f.ok; });
      if (!disp.length) return [];
      var k = disp[0].key;
      return disp.filter(function (f) { return f.key === k; });
    }

    // Combinación más barata de formatos que cubre los gramos pedidos (a igual precio, menos bolsas).
    function combinar(fs, need) {
      if (!fs.length || need <= 0) return null;
      var paso = fs.reduce(function (a, f) { return gcd(a, f.g); }, fs[0].g);
      var maxG = Math.max.apply(null, fs.map(function (f) { return f.g; }));
      var n = Math.ceil((need + maxG) / paso);
      if (n > 20000) { paso = Math.max(paso, Math.ceil((need + maxG) / 20000)); n = Math.ceil((need + maxG) / paso); }
      var coste = [0], bolsas = [0], ult = [-1];
      for (var i = 1; i <= n; i++) {
        coste[i] = Infinity; bolsas[i] = Infinity; ult[i] = -1;
        for (var j = 0; j < fs.length; j++) {
          var s = Math.round(fs[j].g / paso);
          if (s > i || coste[i - s] === Infinity) continue;
          var c = coste[i - s] + fs[j].p, b = bolsas[i - s] + 1;
          if (c < coste[i] || (c === coste[i] && b < bolsas[i])) { coste[i] = c; bolsas[i] = b; ult[i] = j; }
        }
      }
      var desde = Math.ceil(need / paso), mejor = -1;
      for (var t = desde; t <= n; t++) {
        if (coste[t] === Infinity) continue;
        if (mejor < 0 || coste[t] < coste[mejor] || (coste[t] === coste[mejor] && bolsas[t] < bolsas[mejor])) mejor = t;
      }
      if (mejor < 0) return null;
      var usos = {}, pos = mejor;
      while (pos > 0 && ult[pos] >= 0) { var f = fs[ult[pos]]; usos[f.id] = usos[f.id] || { f: f, q: 0 }; usos[f.id].q++; pos -= Math.round(f.g / paso); }
      var lineas = Object.keys(usos).map(function (id) { return usos[id]; }).sort(function (a, b) { return b.f.g - a.f.g; });
      return { lineas: lineas, gramos: mejor * paso, precio: coste[mejor] };
    }
    function texto(lineas) {
      return lineas.map(function (l) { if (!l.f.g) return l.q === 1 ? '1 unidad' : l.q + ' unidades'; return l.q === 1 ? fmtG(l.f.g) : l.q + ' de ' + fmtG(l.f.g); }).join(' + ');
    }
    // Producto sin gramos en el formato (se vende por unidad): una unidad de la primera variante disponible.
    function porUnidad(prod) {
      var v = (prod.v || []).filter(function (x) { return x[3] === true; })[0];
      if (!v) return null;
      return { lineas: [{ f: { id: v[0], g: 0, p: v[2] }, q: 1 }], gramos: 0, precio: v[2] };
    }

    document.querySelectorAll('[data-agplan]').forEach(function (root) {
      var wrap = root.closest('[data-agplan-wrap]') || document;
      var prods = {};
      try { prods = JSON.parse(wrap.querySelector('[data-agplan-prods]').textContent); } catch (e) {}
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-agplan-card]'));
      var selected = {};
      var molido = {};
      var live = root.querySelector('[data-agplan-live]');

      function pick(card, on) {
        var btn = card.querySelector('[data-agplan-pick]');
        var id = card.dataset.id;
        if (on) { try { selected[id] = { name: card.dataset.name, ings: JSON.parse(card.dataset.ings) }; } catch (e) { selected[id] = { name: card.dataset.name, ings: [] }; } }
        else delete selected[id];
        card.classList.toggle('is-on', on);
        card.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (live) live.textContent = (on ? 'Añadida a tu semana: ' : 'Quitada de tu semana: ') + card.dataset.name;
        render();
      }
      cards.forEach(function (card) {
        card.querySelector('[data-agplan-pick]').addEventListener('click', function () { pick(card, !selected[card.dataset.id]); });
      });

      // filtro: buscador + chips con las etiquetas más repetidas; 12 recetas y «Mostrar más» sin filtro
      var qEl = root.querySelector('[data-agplan-q]');
      var chipsBox = root.querySelector('[data-agplan-chips]');
      var noneEl = root.querySelector('[data-agplan-none]');
      var masBtn = root.querySelector('[data-agplan-mas]');
      var masN = root.querySelector('[data-agplan-mas-n]');
      var limite = 12;
      var activeTag = '';
      function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
      function applyFilter() {
        var q = norm(qEl ? qEl.value : '').trim();
        var filtrando = !!(q || activeTag);
        var visibles = 0, coinciden = 0;
        cards.forEach(function (c) {
          var tags = norm(c.dataset.tags).split('|');
          var ok = (!activeTag || tags.indexOf(activeTag) > -1) && (!q || norm(c.dataset.title).indexOf(q) > -1 || norm(c.dataset.tags).indexOf(q) > -1);
          if (ok) coinciden++;
          var ver = ok && (filtrando || coinciden <= limite);
          c.hidden = !ver;
          if (ver) visibles++;
        });
        if (noneEl) noneEl.hidden = coinciden > 0;
        if (masBtn) {
          var quedan = coinciden - visibles;
          masBtn.parentNode.hidden = filtrando || quedan <= 0;
          if (masN) masN.textContent = '(' + quedan + ')';
        }
        if (live && filtrando) live.textContent = coinciden + (coinciden === 1 ? ' receta' : ' recetas');
      }
      if (masBtn) masBtn.addEventListener('click', function () {
        var antes = cards.filter(function (c) { return !c.hidden; }).length;
        limite += 12; applyFilter();
        var sig = cards.filter(function (c) { return !c.hidden; })[antes];
        if (sig) sig.querySelector('[data-agplan-pick]').focus({ preventScroll: false });
      });
      if (chipsBox && cards.length > 8) {
        var freq = {};
        cards.forEach(function (c) { norm(c.dataset.tags).split('|').forEach(function (t) { t = t.trim(); if (t && FUERA.indexOf(t) < 0) freq[t] = (freq[t] || 0) + 1; }); });
        var top = Object.keys(freq).filter(function (t) { return freq[t] >= 3; }).sort(function (a, b) { return freq[b] - freq[a]; }).slice(0, 10);
        [''].concat(top).forEach(function (t) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'agplan-chip';
          b.textContent = t ? bonita(t) : 'Todas';
          b.setAttribute('aria-pressed', t === '' ? 'true' : 'false');
          b.addEventListener('click', function () {
            activeTag = t;
            chipsBox.querySelectorAll('.agplan-chip').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
            applyFilter();
          });
          chipsBox.appendChild(b);
        });
      }
      if (qEl) qEl.addEventListener('input', applyFilter);

      var itemsBox = root.querySelector('[data-agplan-items]');
      var emptyEl = root.querySelector('[data-agplan-empty]');
      var recetasBox = root.querySelector('[data-agplan-recetas]');
      var countEl = root.querySelector('[data-agplan-count]');
      var totalEl = root.querySelector('[data-agplan-total]');
      var msgEl = root.querySelector('[data-agplan-msg]');
      var addBtns = Array.prototype.slice.call(wrap.querySelectorAll('[data-agplan-add]'));
      var bar = wrap.querySelector('[data-agplan-bar]');
      var barTxt = wrap.querySelector('[data-agplan-bar-txt]');
      var barTotal = wrap.querySelector('[data-agplan-bar-total]');
      var plan = [];

      function aggregate() {
        var map = {};
        Object.keys(selected).forEach(function (rid) {
          selected[rid].ings.forEach(function (ing) {
            var pid = String(ing[0]);
            map[pid] = (map[pid] || 0) + (Number(ing[1]) || 0);
          });
        });
        return map;
      }

      function publicarBarra() {
        if (!bar) return;
        var visible = !bar.hidden && getComputedStyle(bar).display !== 'none';
        wrap.classList.toggle('has-bar', visible);
        document.documentElement.style.setProperty('--agplan-bar-h', (visible ? bar.offsetHeight : 0) + 'px');
      }

      function render() {
        var map = aggregate();
        var pids = Object.keys(map);
        itemsBox.querySelectorAll('.agplan-sl').forEach(function (n) { n.remove(); });
        plan = [];
        var total = 0, nIng = 0;
        pids.forEach(function (pid) {
          var prod = prods[pid];
          if (!prod) return;
          var need = map[pid];
          var fs = formatos(prod);
          var comb = fs.length ? combinar(fs, need) : porUnidad(prod);
          var row = document.createElement('div');
          row.className = 'agplan-sl' + (comb ? '' : ' agplan-sl--agotado');
          var info = document.createElement('div'); info.className = 'agplan-sl__info';
          var nm = document.createElement('a'); nm.className = 'agplan-sl__name'; nm.href = prod.u; nm.textContent = prod.n;
          var fm = document.createElement('span'); fm.className = 'agplan-sl__fmt';
          var pr = document.createElement('span'); pr.className = 'agplan-sl__price';
          if (comb) {
            fm.textContent = texto(comb.lineas) + (comb.gramos !== need ? ' · la receta pide ' + fmtG(need) : '');
            pr.textContent = eur(comb.precio);
            total += comb.precio; nIng++;
            plan.push({ pid: pid, cafe: prod.c === 1, lineas: comb.lineas });
          } else {
            fm.textContent = 'Ahora mismo no hay formato disponible · la receta pide ' + fmtG(need);
            pr.textContent = 'Agotado';
          }
          info.appendChild(nm); info.appendChild(fm);
          if (comb && prod.c === 1) {
            var sel = document.createElement('select'); sel.className = 'agplan-sl__molido'; sel.setAttribute('aria-label', 'Molido de ' + prod.n);
            MOLIDOS.forEach(function (m) { var o = document.createElement('option'); o.value = m; o.textContent = m; if ((molido[pid] || 'Grano') === m) o.selected = true; sel.appendChild(o); });
            sel.addEventListener('change', function () { molido[pid] = sel.value; });
            info.appendChild(sel);
          }
          row.appendChild(info); row.appendChild(pr);
          itemsBox.appendChild(row);
        });
        emptyEl.hidden = pids.length > 0;

        // recetas elegidas, con botón para quitarlas
        var ids = Object.keys(selected);
        recetasBox.innerHTML = '';
        recetasBox.hidden = ids.length === 0;
        ids.forEach(function (rid) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'agplan-quita';
          b.setAttribute('aria-label', 'Quitar ' + selected[rid].name);
          b.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
          var s = document.createElement('span'); s.textContent = selected[rid].name; b.appendChild(s);
          b.addEventListener('click', function () { var card = root.querySelector('[data-agplan-card][data-id="' + rid + '"]'); if (card) pick(card, false); });
          recetasBox.appendChild(b);
        });

        var nR = ids.length;
        countEl.textContent = nIng + (nIng === 1 ? ' ingrediente' : ' ingredientes');
        totalEl.textContent = eur(total);
        addBtns.forEach(function (b) { b.disabled = nIng === 0; });
        if (msgEl) msgEl.textContent = '';
        if (bar) {
          bar.hidden = nR === 0;
          barTxt.textContent = nR + (nR === 1 ? ' receta · ' : ' recetas · ') + nIng + (nIng === 1 ? ' ingrediente' : ' ingredientes');
          barTotal.textContent = eur(total);
          publicarBarra();
        }
      }

      function anadir(btn) {
        var items = [];
        plan.forEach(function (p) {
          p.lineas.forEach(function (l) {
            var it = { id: l.f.id, quantity: l.q };
            if (p.cafe) it.properties = { Molido: molido[p.pid] || 'Grano' };
            items.push(it);
          });
        });
        if (!items.length) return;
        var txt = btn.textContent;
        addBtns.forEach(function (b) { b.disabled = true; });
        btn.textContent = 'Añadiendo…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
          .then(function () {
            var n = plan.length;
            var m = 'En tu cesta: ' + n + (n === 1 ? ' ingrediente.' : ' ingredientes.');
            if (msgEl) { msgEl.innerHTML = ''; msgEl.appendChild(document.createTextNode(m + ' ')); var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'Ver cesta'; msgEl.appendChild(a); }
            if (window.AG) { AG.refreshCount(); AG.showToast(m); }
          })
          .catch(function (e) {
            var m = (e && e.description) ? 'No se pudo añadir todo: ' + e.description : 'No se pudo añadir. Inténtalo de nuevo.';
            if (msgEl) msgEl.textContent = m;
            if (window.AG) AG.showToast('No se pudo añadir');
          })
          .then(function () { btn.textContent = txt; addBtns.forEach(function (b) { b.disabled = plan.length === 0; }); });
      }
      addBtns.forEach(function (b) { b.addEventListener('click', function () { anadir(b); }); });

      var ver = wrap.querySelector('[data-agplan-ver]');
      var lista = root.querySelector('.agplan-list');
      if (ver && lista) ver.addEventListener('click', function (e) { e.preventDefault(); lista.scrollIntoView({ block: 'start' }); lista.focus({ preventScroll: true }); });
      window.addEventListener('resize', publicarBarra, { passive: true });

      applyFilter();
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
